import DueDiligenceItemResponsibilitySelectorContainer from './containers/DueDiligenceItemResponsibilitySelectorContainer'

export default DueDiligenceItemResponsibilitySelectorContainer
